import React from "react";
import { Helmet } from "react-helmet-async";

function NotFoundPage({
  navigateTo,
  title = "Page non trouvee",
  message = "La page que vous recherchez n'existe pas ou a ete deplacee.",
  ctaLabel = "Retour a l'accueil",
  ctaPath = "/",
}) {
  return (
    <section style={{ padding: "72px 20px", textAlign: "center", minHeight: "50vh", color: "#f5f5f5" }}>
      <Helmet>
        <title>PAGE NON TROUVEE | FLIP MY CAR</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <h1 style={{ marginBottom: "10px", color: "#f5f5f5" }}>{title}</h1>
      <p style={{ margin: "0 0 24px", color: "#bdbdbd" }}>
        {message}
      </p>

      <button
        type="button"
        onClick={() => navigateTo(ctaPath)}
        style={{
          padding: "12px 24px",
          cursor: "pointer",
          background: "#ffffff",
          color: "#111",
          border: "1px solid #ddd",
          borderRadius: "8px",
          fontSize: "16px",
          fontWeight: 600,
        }}
      >
        {ctaLabel}
      </button>
    </section>
  );
}

export default NotFoundPage;